import { Configuration } from '@core/api/generated/accounts-public/v1';
import { microservices } from '@core/api/microservices.type';
import { environment } from '@environments/environment';

export const ACCOUNTS_PUBLIC_API_CONFIG = new Configuration({
    basePath: `${environment.url}${microservices.accounts_public}`,
});
